export type WipHandoffRedirect = 'wip' | 'completed' | 'admin';

export interface BuildWipHandoffUrlParams {
  wipBaseUrl: string;
  tenantId: string;
  accessToken: string;
  redirect?: WipHandoffRedirect;
}

export function buildWipHandoffUrl(params: BuildWipHandoffUrlParams): string {
  const base = params.wipBaseUrl.replace(/\/$/, '');
  const encodedToken = encodeURIComponent(params.accessToken);
  let url = `${base}/${params.tenantId}/handoff/${encodedToken}/wip`;
  if (params.redirect && params.redirect !== 'wip') {
    url += `?redirect=${encodeURIComponent(params.redirect)}`;
  }
  return url;
}
